import http from '@/plugins/api'
import * as types from './types'
import {
  startLoading
} from '@/plugins/loading'
import globals from '@/plugins/globals.js'
import store from '@/store'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  setRetrospectiveDay({ commit }, data) {
    commit(types.SET_RETRO_DAY, data)
  },
  setStatus({ commit }, status) {
    commit(types.SET_STATUS, status)
  },
  setNewRequest({ commit }) {
    commit('SET_NEW_REQUEST')
  },
  resetVehicle({ commit }) {
    commit('SET_VEHICLEINFO')
  },
  updateDevice({ commit }, device) {
    commit('UPDATE_DEVICE', device)
  },
  totalUnreadChats({ commit }, unread) {
    commit(types.UPDATE_TOTAL_UNREAD, unread)
  },
  updateUnreadChats({ commit }, channels) {
    commit(types.UPDATE_UNREAD, channels)
  },
  resetRequestUnread({ commit }, id) {
    commit(types.RESET_REQUEST_UNREAD, id)
  },
  updateRequestUnread({ commit }, unread) {
    commit(types.UPDATE_REQUEST_UNREAD, unread)
  },
  setSyncColumns({ commit }, value) {
    commit(types.SET_SYNC_COLUMNS, value)
  },
  getStateOptions({
    commit
  }) {
    commit(types.SET_STATE_DEFAULT)
    commit(types.SET_STATE_ASSEMBLY)
    commit(types.SET_STATE_SRS)
    commit(types.SET_STATE_LIGHTS)
    commit(types.SET_STATE_KEY_ENGINE)
    commit(types.SET_STATE_DAMAGE_LEVEL)
    commit(types.SET_STATE_DAMAGE_POSITION)
  },
  refreshRequest({ commit }, data) {
    commit(types.REFRESH_REQUEST, data)
  },
  resetRequests({ commit }) {
    commit(types.RESET_REQUESTS)
  },
  async getServiceRequests({ commit, dispatch }, data) {
    let query = `search=${data.search}&offset=${data.offset}&pageSize=${data.pageSize}&orderBy=${data.orderBy}&sortBy=${data.sortBy}&status=${data.status}&location=${data.location}`
    const r = await startLoading(dispatch, 'getServiceRequests', () =>
      http.get(`ServiceRequest/ServiceRequestsForList?${query}`)
    )
    commit(types.SET_REQUESTS, r.data)
    return r.data
  },
  async serviceRequestExists({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'serviceRequestExists', () =>
      http.get(`ServiceRequest/ServiceRequestExists`, {
        params: options
      })
    )
    return r.data
  },
  async getServiceRequestHistory({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getServiceRequestHistory', () =>
      http.get(`servicerequest/GetServiceRequestHistory?id=${id}`)
    )
    commit(types.SET_REQUEST_HISTORY, r.data)
  },
  async cloneServiceRequest({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'cloneServiceRequest', () =>
      http.get(`ServiceRequest/CloneServiceRequest?id=${data.id}&userid=${data.userid}`)
    )
    commit(types.SET_REQUEST, r.data)
  },
  async getRequestCounts({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getRequestCounts', () =>
      http.get(`ServiceRequest/GetServiceRequestCounts?id=${id}`)
    )
    commit(types.SET_REQUESTCOUNTS, r.data)
    return r.data
  },
  async decodeVin({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'decodeVin', () =>
      http.get(`Decoder/DecodeVinAsTech?vin=${vin}`)
    )
    commit(types.SET_VIN_SUMMARY, r.data)
    return r.data
  },
  async decodeVinUK({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'decodeVin', () =>
      http.get(`Decoder/DecodeVinAsTech?vin=${vin}`)
    )
    commit(types.SET_VIN_SUMMARY, r.data)
    return r.data
  },
  async getVehicleYears({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getVehicleYears', () =>
      http.get(`ServiceRequest/VehicleYears`)
    )
    commit(types.SET_YEARS, r.data)
    return r.data
  },
  async getVehicleMakes({ commit, dispatch }, year) {
    const r = await startLoading(dispatch, 'getVehicleMakes', () =>
      http.get(`ServiceRequest/VehicleMakes?year=${year}`)
    )
    commit(types.SET_MAKES, r.data)
    return r.data
  },
  async getVehicleModels({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getVehicleModels', () =>
      http.get(`ServiceRequest/VehicleModels?year=${data.year}&make=${data.make}`)
    )
    commit(types.SET_MODELS, r.data)
    return r.data
  },
  async getVehicleSubModels({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getVehicleSubModels', () =>
      http.get(`ServiceRequest/VehicleSubModels?year=${data.year}&make=${data.make}&model=${data.model}`)
    )
    commit(types.SET_SUBMODELS, r.data)
    return r.data
  },
  async getVehicleEngines({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getVehicleEngines', () =>
      http.get(`ServiceRequest/VehicleEngines?year=${data.year}&make=${data.make}&model=${data.model}&submodel=${data.submodel}`)
    )
    commit(types.SET_ENGINES, r.data)
    return r.data
  },
  async getVehicleTransmissions({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getVehicleTransmissions', () =>
      http.get(`ServiceRequest/VehicleTransmissions?year=${data.year}&make=${data.make}&model=${data.model}`)
    )
    commit(types.SET_TRANSMISSIONS, r.data)
    return r.data
  },
  async getVehicleDriveTypes({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getVehicleDriveTypes', () =>
      http.get(`ServiceRequest/VehicleDriveTypes?year=${data.year}&make=${data.make}&model=${data.model}`)
    )
    commit(types.SET_DRIVETYPES, r.data)
    return r.data
  },
  async saveVehicleInfo({ commit, dispatch }, data) {
    await startLoading(dispatch, 'saveVehicleInfo', () =>
      http.post(`ServiceRequest/UpdateRequestVehicle`, data))
    commit(types.SET_VEHICLE, data)
  },
  async getScanTypes({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getScanTypes', () =>
      http.get(`ServiceRequest/ScanTypes?locationId=${id}`)
    )
    commit(types.SET_SCANTYPES, r.data)
    return r.data
  },
  async getServiceRequestStatusList({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getServiceRequestStatusList', () =>
      http.get(`ServiceRequest/ServiceRequestStatusList`)
    )
    commit(types.SET_STATUSLIST, r.data)
  },
  async createServiceRequest({ commit, dispatch }, request) {
    request.Contact.Username = globals.username
    const r = await startLoading(dispatch, 'createServiceRequest', () =>
      http.post('ServiceRequest/CreateRequest', request)
    )
    commit(types.SET_REQUESTID, r.data)
    return r.data
  },
  updateRequestRecord({ commit }, data) {
    commit(types.UPDATE_REQUEST_RECORD, data)
  },
  async updateServiceRequest({ commit, dispatch }, request) {
    request.Contact.Username = globals.username
    const r = await startLoading(dispatch, 'updateServiceRequest', () =>
      http.post('ServiceRequest/UpdateRequest', request)
    )
    commit(types.SET_REQUESTID, r.data)
  },
  async updateServiceRequestPriorities({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateServiceRequestPriorities', () =>
      http.post('ServiceRequest/UpdateRequestPriority', data)
    )
    commit(types.SET_REQUESTID, r.data)
  },
  async saveRequestStatus({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveRequestStatus', () =>
      http.post('ServiceRequest/UpdateRequestStatus', data)
    )
    if (parseInt(r.data.id) > 0) {
      commit(types.SET_REQUESTSTATUS, data)
      // TODO: set the Dispatch Status as well.
    }
  },
  async saveRequestScanType({ commit, dispatch }, scanType) {
    const r = await startLoading(dispatch, 'saveRequestScanType', () =>
      http.post(`ServiceRequest/UpdateScanType`, scanType))
    if (r.data) {
      commit(types.SET_REQUEST_SCAN_TYPE, scanType)
    }
    return r.data
  },
  async saveNotes({ commit, dispatch }, note) {
    const r = await startLoading(dispatch, 'saveNotes', () =>
      http.post('ServiceRequest/CreateNote', note))
    commit(types.SET_REQUEST_NOTES, note)
    return r.data
  },
  async setShopDevice({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'setShopDevice', () =>
      http.post(`ServiceRequest/UpdateRequestDevice`, {
        workOrderId: data.workOrderId,
        deviceId: data.device.id
      })
    )
    commit(types.SET_SHOP_DEVICE, data.device)
    return r.data
  },
  async setRequestTool({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'setRequestTool', () =>
      http.post(`ServiceRequest/UpdateRequestDevice`, {
        workOrderId: data.workOrderId,
        toolId: data.toolId
      })
    )
    return r.data
  },
  setScanReportFollowUp({ commit }, value) {
    commit(types.UPDATE_SCAN_REPORT_FOLLOW_UP, value)
  },
  setCalibrationComplete({ commit }, value) {
    commit(types.UPDATE_CALIBRATION_COMPLETE, value)
  },
  setScanReportDetails({
    commit
  }, details) {
    commit(types.UPDATE_SCAN_REPORT, details)
  },
  fetchReport({ commit }, id) {
    let language = store.getters['auth/language']
    if (language !== undefined && language !== null) {
      if (language !== '') {
        language = language + '-' + language.toUpperCase()
      }
    }
    let url = globals.apiUrl() + '/Report/CreatePdf/?workorderId=' + id + '&cultureCode=' + language
    // cordova.InAppBrowser.open('https://docs.google.com/viewer?url=' + url, '_blank', 'location=yes,hidenavigationbuttons=yes,hideurlbar=yes')
    window.open(`https://docs.google.com/viewer?url=${url}`, '_blank')
  },
  async getServiceRequest({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getServiceRequest', () =>
      http.get(`ServiceRequest/ServiceRequest?id=${id}`)
    )
    commit(types.SET_REQUEST, r.data)
  },
  async getScanReport({ dispatch }, data) {
    const r = await startLoading(dispatch, 'getScanReport', () =>
      http.get(`report/CreatePdf?workorderId=${data.id}&cultureCode=${data.code}`)
    )
    return r.data
  },
  async saveDispatchStatus({ commit, dispatch }, status) {
    // update Service Request status in Dispatch
    await startLoading(dispatch, 'updateWorkOrder', () =>
      http.post(`dispatch/UpdateWorkOrder`, status)
    )
    // now, update the Service Request itself
    let _status = {
      Id: status.WorkOrder,
      Status: {
        Id: 0,
        Name: ''
      },
      Notes: null,
      CreatedBy: status.CreatedBy
    }
    if (status.StatusId === 149) { // Dispatch: Closed
      _status.Status.Id = 32
      _status.Status.Name = 'Completed'
    } else if (status.StatusId === 144) { // Dispatch: Submitted
      _status.Status.Id = 41
      _status.Status.Name = 'Submitted'
    } else if (status.StatusId === 146 || status.StatusId === 147 || status.StatusId === 154) { // Dispatch: Scan in Progress, Completed Scan, Report in Progress
      _status.Status.Id = 33
      _status.Status.Name = 'Working'
    } else if (status.StatusId === 143) { // Dispatch: Scheduled
      _status.Status.Id = 142
      _status.Status.Name = 'Scheduled'
    }
    await startLoading(dispatch, 'updateRequestStatus', () =>
      http.post(`serviceRequest/updateRequestStatus`, _status)
    )
    // Update the Service Request's Status locally
    commit(types.SET_REQUESTSTATUS, _status)
    store.dispatch('astechhub/setStatus', { id: status.WorkOrder, statusId: status.StatusId, status: status.StatusName })
    // store.
    return _status
  },
  setScanReportProgrammingPerformed({ commit }, value) {
    let x = 0
    if (value) {
      x = 1
    }
    commit(types.UPDATE_SCAN_REPORT_PERFORMED_PROGRAMMING, x)
  },
  async createScanReport({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveScanReport', () =>
      http.post('Report/CreateScanReport', data))
    return r.data
  },
  async updateScanReport({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveScanReport', () =>
      http.post('Report/UpdateScanReport', data))
    return r.data
  },
  async sendScanReport({ commit, dispatch }, request) {
    const r = await startLoading(dispatch, 'sendScanReport', () =>
      http.post(`report/ScanReportSaved?workorderId=${request}`)
    )
    return r.data
  },
  async sendMobileHandoffRequest({ commit, dispatch }, workorderid) {
    const r = await startLoading(dispatch, 'sendMobileHandoffRequest', () =>
      http.get('Email/SendMobileHandoffRequest', {
        params: {
          workorderid
        }
      })
    )
    return r.data
  },
  async updateMobileHandoff({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateMobileHandoff', () =>
      http.post('Report/updateMobileHandoff', data))
    return r.data
  },
  async getCalibrationConfig({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getCalibrationConfig', () =>
      http.get(`serviceRequest/getCalibration?id=${id}&verbose=true`)
    )
    commit(types.SET_CALIBRATE_CONFIG, r.data)
    return r.data
  },
  updateCalibrateConfig({ commit }, data) {
    commit(types.UPDATE_CALIBRATE_CONFIG, data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/actions.js